import type { FeatureConfig } from 'src/modules/FeatureToggler/types';

// 1. Import your feature configs here.
// 2. Add them to the featureConfigs array.

export const featureConfigs: FeatureConfig[] = [];
